import React from 'react'
//import { Link } from 'react-router-dom';

const Partners = (props) => {
    const colorString = Object.values(props.theme).toString();
    return (
        <section className={colorString === 'true'?`partners customSec dark`: `partners customSec whiteTheme`}>
            <div className="container">
                <div className="partnersBx">
                    <div className="sectionHeading justify-content-center text-center">
                        <div className="d-block">
                            <h2>Partners</h2>
                        </div>
                    </div>
                    <div className="partnersList">
                        <a href="https://polygon.technology/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/polygon.png'} alt="" />
                        </a>
                        <a href="https://bastionex.com/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/bastionex.png'} alt="" />
                        </a>
                        <a href="https://www.payizadlt.com/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/payiza.png'} alt="" />
                        </a>
                        <a href="https://www.pjsglobal.com/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/pajson-global-holding.png'} alt="" />
                        </a>
                        <a href="https://edgecoinpay.com/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/edge-coin.png'} alt="" />
                        </a>
                        <a href="https://diafa.org/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/diafa.png'} alt="" />
                        </a>
                        <a href="http://www.cineyug.com/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/cineyug.png'} alt="" />
                        </a>
                        <a href="http://www.allstarsfootballclub.com/" target="_blank" rel="noreferrer">
                            <img src={process.env.PUBLIC_URL + '/images/partners/AllStar.png'} alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Partners;